import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export const Faq = ({ faqs, heading = "Häufig gestellte Fragen" }) => (
  <div data-testid="faq-section">
    {heading && <h2 className="font-display text-3xl sm:text-4xl font-bold text-navy mb-6">{heading}</h2>}
    <Accordion type="single" collapsible className="space-y-3">
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-accordion-item-${i + 1}`} className="bg-white border border-slate-200 rounded-xl px-5 overflow-hidden">
          <AccordionTrigger className="text-left font-semibold text-navy hover:text-ember py-4 text-[15px]">{f.q}</AccordionTrigger>
          <AccordionContent className="text-slate-600 text-sm leading-relaxed pb-4">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
);
